import logging from '../logging';

export default {
  identify() {
    if (!window.isConsultPortal && logging.isProdEnv()) {
      logging.warn('Support disabled.');
    }
  },
  update() {
    if (!window.isConsultPortal && logging.isProdEnv()) {
      logging.warn('Support disabled.');
    }
  },
};
